import { useEffect, useState, useRef, useCallback, useContext } from "react";
import { getItems } from "../actions/smartLocksActions";
import { usePersistentState } from './usePersistentState';
import { CheckInContext } from "../context/checkin";
import { HotelContext } from "../context/hotel";
import useApi from "./useApi";

export const useSmartLocks = () => {
    const { data: hotel } = useContext(HotelContext);
    const { data: checkIn } = useContext(CheckInContext);
    const { get, post, put, patch } = useApi();
    const [loading, setLoading] = useState(false);
    const [items, setItems] = usePersistentState('smartlocks-v2-' + checkIn?.id || "0", null, 60 * 6)

    useEffect(() => {
        if (!hotel?.id || !checkIn?.id) return;

        console.log('18ago - items', items)

        if (items === null && checkIn.id) {
            console.log('1208 - loadItems - ' + checkIn.id);
            loadItems();
        }
    }, [ hotel, checkIn ])

    const loadItems = async () => {
        try {
            setLoading(true);
            const response = await get(`hotels/${hotel.id}/checkins/${checkIn.id}/smartlocks`);
            console.log('1208 - response', response);
            if (response) {
                setItems(response);
            } else {
                console.error('Error on load smartlocks.');
            }
        } catch (error) {
            console.error('Error on load smartlocks:', error);
        } finally {
            setLoading(false);
        }
    }

    const getByIds = useCallback(ids => {
        console.log('1208 - ids', ids)
        const itemMap = new Map(items?.map(i => [i.id, i]));
        console.log('1208 - itemMap', itemMap)
        return ids.map(id => itemMap.get(id)).filter(Boolean);
    }, [items]);

    const unlock = async (smartLockId) => {
        try {
            setLoading(true);
            const response = await post(`hotels/${hotel.id}/checkins/${checkIn.id}/smartlocks/${smartLockId}/unlock`);
            console.log('1208 - response', response);
            if (response) {
                return response;
                // setItems(response);
            } else {
                console.error('Error on unlock smartlock.');
            }
        } catch (error) {
            console.error('Error on unlock smartlock:', error);
        } finally {
            setLoading(false);
        }
    }

    const clear = () => {
        setItems(null)
    }

    return {
        items,
        getByIds,
        unlock,
        clear
    }

}